module.exports = __webpack_public_path__ + "28e81a16b9d97ecdcfd2ead04ab2f9ba.svg";